import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface TimeSquareIconProps {
  color?: string;
  size?: number;
}

export default function TimeSquareIcon({ color = '#151515', size = 16 }: TimeSquareIconProps) {
  return (
    <Svg width={size} height={size} viewBox="-1 -1 17.42 17.42" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.32 0H4.09583C1.57833 0 0 1.7825 0 4.305V11.1117C0 13.6342 1.57 15.4167 4.09583 15.4167H11.3192C13.845 15.4167 15.4167 13.6342 15.4167 11.1117V4.305C15.4167 1.7825 13.845 0 11.32 0Z"
        fill="white"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.5329 9.38982L7.70703 7.70399V4.06982"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
